import React, { useState } from 'react';
import styled from 'styled-components';

const Card = styled.div`
  flex: 1;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;
  padding: 20px 24px;
  transition: border-color 0.25s, box-shadow 0.25s;

  &:hover {
    border-color: ${({ theme }) => theme.primary};
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }
`;

const Top = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 12px;
`;

const LogoImg = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  object-fit: contain;
  background: #1a1a2e;
  flex-shrink: 0;
  padding: 4px;
`;

const LogoFallback = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: ${({ theme }) => theme.primary_light};
  border: 1px solid ${({ theme }) => theme.border};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.primary};
`;

const Meta = styled.div`
  flex: 1;
  min-width: 0;
`;

const Role = styled.h3`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  margin-bottom: 3px;
`;

const Company = styled.p`
  font-size: 13.5px;
  font-weight: 500;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 2px;
`;

const DateRange = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.text_secondary};
`;

const Description = styled.p`
  font-size: 13.5px;
  line-height: 1.7;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 12px;
`;

const SkillsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
`;

const SkillTag = styled.span`
  font-size: 11px;
  font-weight: 500;
  padding: 3px 10px;
  border-radius: 100px;
  background: ${({ theme }) => theme.primary_light};
  color: ${({ theme }) => theme.primary};
  border: 1px solid ${({ theme }) => theme.border};
`;

const CompanyLogo = ({ src, company }) => {
  const [errored, setErrored] = useState(false);
  const initial = company?.charAt(0).toUpperCase() || '?';

  if (!src || errored) {
    return <LogoFallback>{initial}</LogoFallback>;
  }
  return <LogoImg src={src} alt={company} onError={() => setErrored(true)} />;
};

const ExperienceCard = ({ experience }) => {
  return (
    <Card>
      <Top>
        <CompanyLogo src={experience.img} company={experience.company} />
        <Meta>
          <Role>{experience.role}</Role>
          <Company>{experience.company}</Company>
          <DateRange>{experience.date}</DateRange>
        </Meta>
      </Top>
      {experience.desc && <Description>{experience.desc}</Description>}
      {experience.skills?.length > 0 && (
        <SkillsRow>
          {experience.skills.map((skill, i) => (
            <SkillTag key={i}>{skill}</SkillTag>
          ))}
        </SkillsRow>
      )}
    </Card>
  );
};

export default ExperienceCard;
